import React, { useState } from 'react';

import styled from 'styled-components';

import { DesktopIcon } from 'assets/icons/desktop-icon';
import { MobilePhoneIcon } from 'assets/icons/mobile-phone-icon';
import { Modal } from 'src/app/components/lib/modal';

type TemplatePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  templateHTML: string;
};

export function TemplatePreviewModal({ templateHTML, isOpen, onClose }: TemplatePreviewModalProps) {
  const [showMobilePreview, setShowMobilePreview] = useState(false);

  return (
    <Modal
      Content={
        <Container>
          <EmailPreviewViewSwitcher>
            <PreviewModeButton $selected={!showMobilePreview} onClick={() => setShowMobilePreview(false)}>
              <ButtonContents>
                <DesktopIcon />
                Desktop
              </ButtonContents>
            </PreviewModeButton>
            <PreviewModeButton $selected={showMobilePreview} onClick={() => setShowMobilePreview(true)}>
              <ButtonContents>
                <MobilePhoneIcon />
                Mobile
              </ButtonContents>
            </PreviewModeButton>
          </EmailPreviewViewSwitcher>
          <EmailPreviewBody>
            <EmailPreviewBodyContainer $isMobilePreview={showMobilePreview}>
              <iframe frameBorder='0' height='575px' srcDoc={templateHTML} title='email-preview' width='100%' />
            </EmailPreviewBodyContainer>
          </EmailPreviewBody>
        </Container>
      }
      open={isOpen}
      primaryActions={[
        {
          label: 'Done',
          onClick: onClose,
        },
      ]}
      title='Template preview'
      width='1000px'
      onClose={onClose}
    />
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const EmailPreviewViewSwitcher = styled.div`
  background-color: var(--color-gray-10);
  padding: var(--sizes-20);
  border-radius: 7px;
  border: 1px solid var(--color-gray-20);
  display: flex;
  align-items: center;
  width: 533px;
`;
const PreviewModeButton = styled.div<{ $selected: boolean }>`
  background-color: ${({ $selected }) => ($selected ? 'var(--color-brand-primary-white)' : 'transparent')};
  border-radius: 7px;
  font: var(--font-extra-small-12pt-semibold);
  width: 50%;
  height: 30px;
  padding: 6px var(--sizes-30);
  display: flex;
  justify-content: center;
`;
const ButtonContents = styled.div`
  display: flex;
  align-items: center;
  gap: var(--sizes-20);
`;
const EmailPreviewBody = styled.div`
  width: 100%;
  padding: var(--sizes-60);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const EmailPreviewBodyContainer = styled.div<{ $isMobilePreview: boolean }>`
  width: ${({ $isMobilePreview }) => ($isMobilePreview ? '390px' : '100%')};
`;
